import {getCookie,setCookie} from './cookies.js';
import axios from 'axios';
import ElementUI from 'element-ui';
var qs = require('qs');
export function ajpost(url,data,call,err) {
  var token = '',
      header = {};
  try{
    token = JSON.parse(getCookie('userInfo')).token;
    if(!token){
      window.location = '/index';
      return;
    }else {
      setCookie('token',token,1);
    }
  }catch (err){
  }
  if(url !='/api/account/login'){
    header = {
      'x-access-token' : token
    }
  }
  if(data.imgStr){
    // var formData = new FormData();
    // formData.append("imgStr", data.imgStr);
    // data = formData;
    // url = `${url}?imgStr=${data.imgStr}`
    data = qs.stringify(data)
  }
  let wtUrl = window.wtEnv.baseApiUrl + url
  axios({
    method:'post',
    url: wtUrl,
    headers : header,
    data:data
  }).then(function(re){
    call(re.data);
  }).catch(function (error) {
    err(error);
  });
}

function parseQueryString() {
  var url = window.location.hash
  var json = {};
  var arr = url.substr(url.indexOf('?') + 1).split('&');
  arr.forEach(function(item) {
    var tmp = item.split('=');
    json[tmp[0]] = tmp[1];
  })
  return json;
}



// WEBPACK FOOTER //
// ./src/common/ajax.js